// extracted by mini-css-extract-plugin
export var closeButton = "_28-3";
export var header = "_28-0";
export var link = "_28-1";
export var retryButton = "_28-2";